import config from '../../../../config';
import { ValidBusinessObjectNode } from '../components/ValidBusinessObjectNode';
import { defaultTypeToNodeMap } from './defaultTypeToNodeMap';
/** for loading venture-specific overrides */
const appCode = config.app.appCode.substring(0, 4);
const debug = process.env.REACT_APP_DEBUG && false;
/**
 * Resolve type-to-node map to either LSC default, or venture-specific override
 */
const typeToNodeMap = await import(/* webpackPreload: true  */ `../../../../venture/${appCode}/components/EntityNetwork`)
    .then((module) => {
    debug && console.log('EntityNetwork Schematic nodes loaded venture-specific type to node map:', module.typeToNodeMap);
    return module.typeToNodeMap;
})
    .catch((_) => {
    debug && console.log('No venture-specific type to node map, using default...');
    return defaultTypeToNodeMap;
});
/**
 * Given an LSC type, use the {@link typeToNodeMap | `typeToNodeMap`} to resolve it to a renderable component
 */
export const resolveNode = (type) => {
    debug && console.log('resolveNode', 'resolving node', type);
    const venture = typeToNodeMap[type];
    const lsc = defaultTypeToNodeMap[type];
    const fallback = ValidBusinessObjectNode;
    const resolved = (venture ?? lsc ?? fallback);
    return resolved;
};
